export default __webpack_public_path__ + "static/media/offline.e617760d.svg";